export default function className(classes) {
    return classes.join(' ');
}